import React, { useState } from "react";

//styling
import "./clusterRow.css";

//material ui
import ShowChartIcon from "@material-ui/icons/ShowChart";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import CloudIcon from "@material-ui/icons/Cloud";
import VpnLockIcon from "@material-ui/icons/VpnLock";
import Typography from "@material-ui/core/Typography";

import ApiKeyModal from "./ClusterApiKeyModal";

import Link from "@material-ui/core/Link";

const ClusterRowMobileInfoHTMLContentTop = ({
  clusterInfo,
  classes,
  percentage,
}) => {
  const [showApiKeyModal, setShowApiKeyModal] = useState(false);

  const sandboxId = clusterInfo.data.id;
  const authRequired = clusterInfo.data.configuration.requiresAuthentication;
  const apiKey = clusterInfo.data.configuration.apiKey;

  const openApiKeyModal = () => {
    setShowApiKeyModal(true);
  };

  const hideApiKeyModal = () => {
    setShowApiKeyModal(false);
  };

  const getModuleNames = (modules) => {
    return modules.map((m) => m.name).join(", ");
  };

  return (
    <>
      <h2 className={classes.id}>{clusterInfo.data.id}</h2>
      <div className={classes.content}>
        <div className={classes.labelDiv}>
          <ShowChartIcon
            style={{
              color: percentage === 100 ? "#38d611" : null,
            }}
          />

          <label className={classes.label}>Status</label>
        </div>

        <Typography className={classes.text}>
          {percentage === 100
            ? "online (100%)"
            : `offline(${Math.ceil(percentage) + "%"})`}
        </Typography>
      </div>
      <div className={classes.content}>
        <div className={classes.labelDiv}>
          <ViewModuleIcon />
          <label className={classes.label}>Modules</label>
        </div>
        <Typography className={classes.text}>
          {clusterInfo.data.configuration.modules &&
          clusterInfo.data.configuration.modules[0]
            ? getModuleNames(clusterInfo.data.configuration.modules)
            : "none"}
        </Typography>
      </div>
      <div className={classes.content}>
        <div className={classes.labelDiv}>
          <CloudIcon />
          <label className={classes.label}>Tier</label>
        </div>
        <Typography className={classes.text}>
          {clusterInfo.data.configuration.tier}
        </Typography>
      </div>

      <div className={classes.content}>
        <div className={classes.labelDiv}>
          <VpnLockIcon />
          <label className={classes.label}>Authentication</label>
        </div>
        <Typography className={classes.text}>
          <span>{authRequired ? "Enabled" : "public"}</span>
          {authRequired && !!apiKey ? (
            <Link className="__apiKeyButton" href="#" onClick={openApiKeyModal}>
              Show API Key
            </Link>
          ) : null}
        </Typography>
        {authRequired && !!apiKey ? (
          <ApiKeyModal
            sandboxId={sandboxId}
            apiKey={apiKey}
            open={showApiKeyModal}
            closeFn={hideApiKeyModal}
          />
        ) : null}
      </div>
    </>
  );
};

export default ClusterRowMobileInfoHTMLContentTop;
